module.exports = __webpack_public_path__ + "1048d71b039ca7283d87eec6a529b0a0.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js!./src/client/res/images/default-avatar.png
// module id = 727
// module chunks = 0